import { MDBBtn, MDBIcon, MDBModalFooter } from "mdb-react-ui-kit";
import React, { forwardRef, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { getMisc } from "../../../../apiclients/streamsapi_bridge";
import { getMultiSelectRequest, setMultiSelectValue } from "../../misc/MultiSelectRequest";
import PopupLoader from "../../PopupLoader";
import MultiSaveLimitAlert from "../../../../apiclients/MultiSaveLimitAlert";
const ChangeLocation = forwardRef((props, ref) => {
  const [selectedRegion, setSelectedRegion] = useState("IN");
  const [locations, setlocations] = useState([]);
  const [location, setlocation] = useState(-1);
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [warningMsg, setwarningMsg] = useState([]);
  const [showWarning, setShowWarning] = useState(false);
  const warningToggle = () => setShowWarning(!showWarning);
  const [saveWarningMessage, setsaveWarningMessage] = useState("");
  const [allEntriesDicard, setAllEntriesDicard] = useState(false);

  useEffect(() => {
    getLocations();

  }, []);
  async function getLocations() {
    props.setIsloading(true);
    const tdata = await getMultiSelectRequest(3, props.agentList, props.moduleType);
    props.setIsloading(false);
    if (!tdata) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    //setServices(tdata.misc.services);
    setlocations(tdata?.result?.option_list ?? []);
    setwarningMsg(tdata?.result?.message ? [tdata?.result?.message] : []);

  }

  async function handleLocationChange(value) {
    props.setIsloading(true);
    const tdata = await setMultiSelectValue(3, value + "", props.agentList, props.moduleType);
    props.setIsloading(false);
    if (!tdata) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    console.log("handleLocationChange for multi select ::::::::::::: " + JSON.stringify(tdata));
    const reponseMsg = tdata.display_Info ?? [];
    if (reponseMsg.length > 0) {
      setwarningMsg(reponseMsg);
    }
  }

  async function onsubmit(confirmFlag) {
    if (parseInt(location) === -1) {
      setError("Please select a Location");
      return;
    }
    let tdata = null;
    props.setIsloading(true);
    if (confirmFlag) {
      tdata = await setMultiSelectValue(3, location + "", props.agentList, props.moduleType, 1, 1);
    } else {
      tdata = await setMultiSelectValue(3, location + "", props.agentList, props.moduleType, 1);
    }
    props.setIsloading(false);
    if (!tdata) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    if (tdata.status == "Failed") {
      localStorage.setItem(
        "user_create_f",
        "Something went wrong, Please try again after sometime"
      );
      props.onClose();
      window.location.href = "/userlanding";
    } else if (tdata.status == "failed") {
      if (tdata.exceededErrMsg) {
        setsaveWarningMessage(tdata.exceededErrMsg);
        if(tdata.all_grps_discarded) {
                    setAllEntriesDicard(true);
                }
        warningToggle();
        return;
      }
    } else {
      console.log("location for multi select ::::::::::::: " + JSON.stringify(tdata));
      localStorage.setItem("s_message", tdata.message);

      if (props.locUser) {
        navigate("/locationsusers", {
          state: { tab: props.locUser },
        });

      } else if (props.groupInfo) {
        navigate("/usersgroups", {
          state: { tab: props.groupInfo },
        });

      } else if (props.groupUInfo) {
        navigate("/SelectedUserGroupSettings", {
          state: { tab: "tab2", groupUInfo: props.groupUInfo },
        });
      } else if (props.usergroups) {
        navigate("/userlanding", {
          state: { tab: "mgroups" },
        });

      } else if (props.userLoc) {
        navigate("/userlanding", {
          state: { tab: "suser", tab2: "sloc" },
        });

      } else if (props.userAllgroups) {
        navigate("/userlanding", {
          state: { tab: "suser", tab2: "sgroups" },
        });

      } else {
        navigate("/userlanding", {
          state: { tab: "suser", tab2: "suser" },
        });
      }
      props.onClose();

      window.location.reload();
    }

  }

  return (
    <>
      <div style={{ paddingBottom: 125 }}>
        <div>
          <strong className=" d-block">
            {t("ChangeLoc")}
          </strong>
          <select
            className="form-select form-control w-100 mt-2"
            value={location}
            onChange={(e) => {
              setlocation(e.target.value);
              if (parseInt(e.target.value) === -1) {
                setError("Please select a Location");
              } else {
                setError("");
                handleLocationChange(e.target.value);
              }
            }}
          >
            <option value={-1}>-- Select Location --</option>
            {locations && locations.length > 0 && locations.map((location) => (
              <option value={location.loc_id}>{location.loc_name}</option>
            ))}
          </select>
          {error && (
            <p className="text-danger">{error}</p>
          )}
        </div>
        {warningMsg && warningMsg.map((meg) => (
          <div className="pt-2 phrecording">
            {meg}
          </div>
        ))}
      </div>
      <div style={{ display: "none" }}>
        <button ref={ref} onClick={(e) => {
          e.preventDefault();
          onsubmit();
        }}>
          {t("add")}</button>
      </div>
      {showWarning && (
        <>
          <PopupLoader
            title="Warning"
            content={
              <MultiSaveLimitAlert
                saveWarningMessage={saveWarningMessage}
                onClose={warningToggle}
                handleClick={() => { if(allEntriesDicard) {warningToggle(); props.onClose(); return;}onsubmit(1);}}
              />
            }
            onShow={setShowWarning}
            onClose={warningToggle}
          />

        </>
      )}
    </>
  )
});

export default ChangeLocation
